import Vue from 'vue'
export default {
  created: function () {
    Vue.filter('sourceTypeFilter', function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '智能选车'
          break
        case 2:
          str = '资讯详情'
          break
        case 3:
          str = '新车评测'
          break
        case 4:
          str = '汽车新闻'
          break
        case 5:
          str = '车系详情'
          break
        case 6:
          str = '帮我找车'
          break
        case 7:
          str = '本地询价'
          break
        case 8:
          str = '首页询底价'
          break
        case 9:
          str = '车型对比'
          break
        case 10:
          str = '购车计算'
          break
        case 11:
          str = '购车顾问'
          break
        case 12:
          str = '弹窗询价'
          break
        case 13:
          str = '网上车展'
          break
        case 14:
          str = '高价卖车'
          break
        case 15:
          str = '车辆估价'
          break
        default:
      }

      return str
    })

    Vue.filter('defaultFilter', function (valueFilter) {
      return valueFilter != null ? valueFilter : 0
    })

    Vue.filter('lcwStatusFilter', function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '待审核'
          break
        case 2:
          str = '有效'
          break
        case 3:
          str = '无效'
          break
        default:
      }

      return str
    })

    Vue.filter('coinWithdrawCashPayFilter', function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '支付成功'
          break
        case 2:
          str = '支付失败'
          break
        case 3:
          str = '待处理'
          break
        default:
      }

      return str
    })

    Vue.filter('coinWithdrawCashFilter', function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '待审核'
          break
        case 2:
          str = '通过'
          break
        case 3:
          str = '不通过'
          break
        case 4:
          str = '暂缓'
          break
        case 5:
          str = '异常'
          break
        default:
      }
      return str
    })

    Vue.filter('withdrawCashStateFilter', function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '提现成功'
          break
        case 2:
          str = '提现失败'
          break
        default:
      }

      return str
    })

    Vue.filter('bannerTargetFilter', function (targetType) {
      let targets = targetType.split(',')

      let targetArray = []
      for (var i = 0; i < targets.length; i++) {
        let target = targets[i]

        let targetStr = ''
        switch (target) {
          case '1':
            targetStr = '顶部banner'
            break
          case '4':
            targetStr = '活动专区'
            break
          case '5':
            targetStr = '首页中部banner'
            break
          case '6':
            targetStr = '本地资讯'
            break
          case '7':
            targetStr = '资讯流广告'
            break
          case '8':
            targetStr = '首页弹窗广告'
            break
          case '9':
            targetStr = '商家页顶部banner'
            break
          case '10':
            targetStr = '资讯页顶部banner'
            break
          case '11':
            targetStr = '小程序首页顶部banner'
            break
          case '12':
            targetStr = '小程序活动专区'
          case '13':
            targetStr = '首页banner'
            break
        }
        targetArray.push(targetStr)
      }

      return targetArray.join(',')
    })

    Vue.filter('orderFilter', function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '待支付'
          break
        case 2:
          str = '支付成功'
          break
        case 3:
          str = '支付失败'
          break
        case 4:
          str = '支付关闭'
          break
        case 5:
          str = '转入退款'
          break
        default:
      }

      return str
    })

    Vue.filter('businessOrderFilter', function (valueFilter) {
      let str = ''

      if (valueFilter === 2) {
        str = '已支付'
      } else {
        str = '未支付'
      }

      return str
    })

    Vue.filter('businessStateFilter', function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 0:
          str = '已下架'
          break
        case 1:
          str = '已上架'
          break
        case 3:
          str = '待上架'
          break
      }
      return str
    })

    Vue.filter('eventFilter', function (targetType) {
      let targetTypeStr = ''
      switch (targetType) {
        case 'changedPage':
          targetTypeStr = '打开页面'
          break
        case 'click':
          targetTypeStr = '点击'
          break
        case 'loadPage':
          targetTypeStr = '刷新页面'
          break
      }
      return targetTypeStr
    })

    Vue.filter('channelStatusFilter', function (status) {
      let targetTypeStr = ''
      switch (status) {
        case 0:
          targetTypeStr = '关闭'
          break
        case 1:
          targetTypeStr = '正常'
          break
      }
      return targetTypeStr
    })

    Vue.filter('mainBrandJson', function (mainBrandJson) {
      if (!mainBrandJson) {
        return
      }

      let mainBrands = JSON.parse(mainBrandJson)

      let str = null
      for (var i = 0; i < mainBrands.length; i++) {
        let mainBrand = mainBrands[i]
        if (str) {
          str += ','
        } else {
          str = ''
        }
        str += mainBrand.brandName + '-' + mainBrand.seriesName
      }
      return str
    })

    // 线索评价
    Vue.filter('clueEvaluateTypeFilter', function (targetType) {
      // 0-待评价
      // 1-差评
      // 2-中评
      // 3-好评
      let targetTypeStr = ''
      switch (targetType) {
        case 0:
          targetTypeStr = '待评价'
          break
        case 1:
          targetTypeStr = '差评'
          break
        case 2:
          targetTypeStr = '中评'
          break
        case 3:
          targetTypeStr = '好评'
          break
      }
      return targetTypeStr
    })
    // 线索类型
    Vue.filter('clueTypeFilter', function (targetType) {
      // 1-有效线索、2-重复线索、3-指定线索
      //              ①有效线索：指3日内首次询价的线索
      //              ②重复线索：指3日内非首次询价的线索（以手机号来判定）
      //              ③指定线索：指向指定商家询价的线索
      let targetTypeStr = ''
      switch (targetType) {
        case 1:
          targetTypeStr = '唯一线索'
          break
        case 2:
          targetTypeStr = '重复线索'
          break
        case 3:
          targetTypeStr = '指定线索'
          break
      }
      return targetTypeStr
    })
    // 线索状态
    Vue.filter('clueStateFilter', function (targetType) {
      // 状态:1-等待领取、2-已付费查看、3-已评价

      let targetTypeStr = ''
      switch (targetType) {
        case 1:
          targetTypeStr = '等待领取'
          break
        case 2:
          targetTypeStr = '已付费查看'
          break
        case 3:
          targetTypeStr = '已评价'
          break
      }
      return targetTypeStr
    })
    // 社区账号风险标识
    Vue.filter('lcwUserBadFlagFilter', function (targetType) {
      // 状态:1-等待领取、2-已付费查看、3-已评价

      let targetTypeStr = ''
      switch (targetType) {
        case 1:
          targetTypeStr = '待检查'
          break
        case 2:
          targetTypeStr = '异常'
          break
        case 3:
          targetTypeStr = '正常'
          break
        case 4:
          targetTypeStr = '可信度低'
          break
        case 5:
          targetTypeStr = '未找到'
          break
      }
      return targetTypeStr
    })
  }
}
